/* eslint-disable react/no-unescaped-entities */
import {styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import {Divider} from '@mui/material'

import LegalNoticeTable from './LegalNoticeTable'

const PREFIX = 'LegalNotice'

const classes = {
  underlineHeadings: `${PREFIX}-underlineHeadings`,
  bottomMargin: `${PREFIX}-bottomMargin`,
  bgColor: `${PREFIX}-bgColor`
}

const Root = styled('div')(({theme}) => ({
  [`& .${classes.underlineHeadings}`]: {
    textDecoration: 'underline'
  },

  [`& .${classes.bottomMargin}`]: {
    marginBottom: '20px'
  },

  [`& .${classes.bgColor}`]: {
    backgroundColor: theme.palette.hpAccentBlue
  }
}))
const LegalNotice = () => {
  return (
    <Root tabIndex={0} aria-label='legal-notice'>
      <Typography
        tabIndex={0}
        variant='titleMedium'
        component='div'
        gutterBottom
        align='center'
        className={classes.bgColor}
      >
        HealthPrism 5.2 Attribution Report <br />
        Open Source Components: May 12, 2026 Scan
      </Typography>
      <Typography tabIndex={0} variant='titleMedium' component='div' gutterBottom>
        SUMMARY
      </Typography>
      <Divider className={classes.bottomMargin} />
      <Typography tabIndex={0} variant='captionLarge' component='div' className={classes.bottomMargin} gutterBottom>
        This application uses certain open source software. As required by the terms of the open source license
        applicable to such open source software, we are providing you with the following notices:
      </Typography>
      <LegalNoticeTable />
      <Typography tabIndex={0} variant='headingSmall' component='div' gutterBottom className={classes.bottomMargin}>
        APPENDIX
      </Typography>
      <Divider className={classes.bottomMargin} />
      <Typography
        tabIndex={0}
        className={classes.underlineHeadings}
        variant='subtitleMedium'
        component='div'
        gutterBottom
      >
        License Details
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        1. MIT
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          MIT License
          <br />
          <br />
          Copyright (c) &lt;year&gt; &lt;copyright holders&gt;
          <br />
          <br />
          Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated
          documentation files (the "Software"), to deal in the Software without restriction, including without
          limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the
          Software, and to permit persons to whom the Software is furnished to do so, subject to the following
          conditions:
          <br />
          <br />
          The above copyright notice and this permission notice (including the next paragraph) shall be included in all
          copies or substantial portions of the Software.
          <br />
          <br />
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
          TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
          THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF
          CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER
          DEALINGS IN THE SOFTWARE.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        2. ISC
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          ISC License
          <br />
          <br />
          &lt;copyright notice&gt;
          <br />
          <br />
          Permission to use, copy, modify, and /or distribute this software for any purpose with or without fee is
          hereby granted, provided that the above copyright notice and this permission notice appear in all copies.
          <br />
          <br />
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE
          INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
          ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
          DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
          CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        3. Zlib
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          zlib License
          <br />
          <br />
          Copyright (c) &lt;year&gt; &lt;copyright holders&gt;
          <br />
          <br />
          This software is provided 'as-is', without any express or implied warranty. In no event will the authors be
          held liable for any damages arising from the use of this software.
          <br />
          <br />
          Permission is granted to anyone to use this software for any purpose, including commercial applications, and
          to alter it and redistribute it freely, subject to the following restrictions:
          <br />
          <br />
          1. The origin of this software must not be misrepresented; you must not claim that you wrote the original
          software. If you use this software in a product, an acknowledgment in the product documentation would be
          appreciated but is not required.
          <br />
          2. Altered source versions must be plainly marked as such, and must not be misrepresented as being the
          original software.
          <br />
          3. This notice may not be removed or altered from any source distribution.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        4. Apache 2.0
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          Apache License
          <br />
          Version 2.0, January 2004
          <br />
          http://www.apache.org/licenses/
          <br />
          <br />
          TERMS AND CONDITIONS FOR USE, REPRODUCTION, AND DISTRIBUTION
          <br />
          <br />
          1. Definitions.
          <br />
          "License" shall mean the terms and conditions for use, reproduction, and distribution as defined by Sections 1
          through 9 of this document.
          <br />
          <br />
          "Licensor" shall mean the copyright owner or entity authorized by the copyright owner that is granting the
          License.
          <br />
          <br />
          "Legal Entity" shall mean the union of the acting entity and all other entities that control, are controlled
          by, or are under common control with that entity. For the purposes of this definition, "control" means (i) the
          power, direct or indirect, to cause the direction or management of such entity, whether by contract or
          otherwise, or (ii) ownership of fifty percent (50%) or more of the outstanding shares, or (iii) beneficial
          ownership of such entity.
          <br />
          <br />
          "You" (or "Your") shall mean an individual or Legal Entity exercising permissions granted by this License.
          <br />
          <br />
          "Source" form shall mean the preferred form for making modifications, including but not limited to software
          source code, documentation source, and configuration files.
          <br />
          <br />
          "Object" form shall mean any form resulting from mechanical transformation or translation of a Source form,
          including but not limited to compiled object code, generated documentation, and conversions to other media
          types.
          <br />
          <br />
          "Work" shall mean the work of authorship, whether in Source or Object form, made available under the License,
          as indicated by a copyright notice that is included in or attached to the work (an example is provided in the
          Appendix below).
          <br />
          <br />
          "Derivative Works" shall mean any work, whether in Source or Object form, that is based on (or derived from)
          the Work and for which the editorial revisions, annotations, elaborations, or other modifications represent,
          as a whole, an original work of authorship. For the purposes of this License, Derivative Works shall not
          include works that remain separable from, or merely link (or bind by name) to the interfaces of, the Work and
          Derivative Works thereof.
          <br />
          <br />
          "Contribution" shall mean any work of authorship, including the original version of the Work and any
          modifications or additions to that Work or Derivative Works thereof, that is intentionally submitted to
          Licensor for inclusion in the Work by the copyright owner or by an individual or Legal Entity authorized to
          submit on behalf of the copyright owner. For the purposes of this definition, "submitted" means any form of
          electronic, verbal, or written communication sent to the Licensor or its representatives, including but not
          limited to communication on electronic mailing lists, source code control systems, and issue tracking systems
          that are managed by, or on behalf of, the Licensor for the purpose of discussing and improving the Work, but
          excluding communication that is conspicuously marked or otherwise designated in writing by the copyright owner
          as "Not a Contribution."
          <br />
          <br />
          "Contributor" shall mean Licensor and any individual or Legal Entity on behalf of whom a Contribution has been
          received by Licensor and subsequently incorporated within the Work.
          <br />
          <br />
          2. Grant of Copyright License. Subject to the terms and conditions of this License, each Contributor hereby
          grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to
          reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the
          Work and such Derivative Works in Source or Object form.
          <br />
          3. Grant of Patent License. Subject to the terms and conditions of this License, each Contributor hereby
          grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable (except as stated in
          this section) patent license to make, have made, use, offer to sell, sell, import, and otherwise transfer the
          Work, where such license applies only to those patent claims licensable by such Contributor that are
          necessarily infringed by their Contribution(s) alone or by combination of their Contribution(s) with the Work
          to which such Contribution(s) was submitted. If You institute patent litigation against any entity (including
          a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the
          Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under
          this License for that Work shall terminate as of the date such litigation is filed.
          <br />
          4. Redistribution. You may reproduce and distribute copies of the Work or Derivative Works thereof in any
          medium, with or without modifications, and in Source or Object form, provided that You meet the following
          conditions:
          <br />
          (a) You must give any other recipients of the Work or Derivative Works a copy of this License; and
          <br />
          (b) You must cause any modified files to carry prominent notices stating that You changed the files; and
          <br />
          (c) You must retain, in the Source form of any Derivative Works that You distribute, all copyright, patent,
          trademark, and attribution notices from the Source form of the Work, excluding those notices that do not
          pertain to any part of the Derivative Works; and
          <br />
          (d) If the Work includes a "NOTICE" text file as part of its distribution, then any Derivative Works that You
          distribute must include a readable copy of the attribution notices contained within such NOTICE file,
          excluding those notices that do not pertain to any part of the Derivative Works, in at least one of the
          following places: within a NOTICE text file distributed as part of the Derivative Works; within the Source
          form or documentation, if provided along with the Derivative Works; or, within a display generated by the
          Derivative Works, if and wherever such third-party notices normally appear. The contents of the NOTICE file
          are for informational purposes only and do not modify the License. You may add Your own attribution notices
          within Derivative Works that You distribute, alongside or as an addendum to the NOTICE text from the Work,
          provided that such additional attribution notices cannot be construed as modifying the License.
          <br />
          You may add Your own copyright statement to Your modifications and may provide additional or different license
          terms and conditions for use, reproduction, or distribution of Your modifications, or for any such Derivative
          Works as a whole, provided Your use, reproduction, and distribution of the Work otherwise complies with the
          conditions stated in this License.
          <br />
          <br />
          5. Submission of Contributions. Unless You explicitly state otherwise, any Contribution intentionally
          submitted for inclusion in the Work by You to the Licensor shall be under the terms and conditions of this
          License, without any additional terms or conditions. Notwithstanding the above, nothing herein shall supersede
          or modify the terms of any separate license agreement you may have executed with Licensor regarding such
          Contributions.
          <br />
          6. Trademarks. This License does not grant permission to use the trade names, trademarks, service marks, or
          product names of the Licensor, except as required for reasonable and customary use in describing the origin of
          the Work and reproducing the content of the NOTICE file.
          <br />
          7. Disclaimer of Warranty. Unless required by applicable law or agreed to in writing, Licensor provides the
          Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS
          OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE,
          NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for
          determining the appropriateness of using or redistributing the Work and assume any risks associated with Your
          exercise of permissions under this License.
          <br />
          8. Limitation of Liability. In no event and under no legal theory, whether in tort (including negligence),
          contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or
          agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect,
          special, incidental, or consequential damages of any character arising as a result of this License or out of
          the use or inability to use the Work (including but not limited to damages for loss of goodwill, work
          stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such
          Contributor has been advised of the possibility of such damages.
          <br />
          9. Accepting Warranty or Additional Liability. While redistributing the Work or Derivative Works thereof, You
          may choose to offer, and charge a fee for, acceptance of support, warranty, indemnity, or other liability
          obligations and/or rights consistent with this License. However, in accepting such obligations, You may act
          only on Your own behalf and on Your sole responsibility, not on behalf of any other Contributor, and only if
          You agree to indemnify, defend, and hold each Contributor harmless for any liability incurred by, or claims
          asserted against, such Contributor by reason of your accepting any such warranty or additional liability.
          <br />
          END OF TERMS AND CONDITIONS
          <br />
          <br />
          APPENDIX: How to apply the Apache License to your work.
          <br />
          <br />
          To apply the Apache License to your work, attach the following boilerplate notice, with the fields enclosed by
          brackets "[]" replaced with your own identifying information. (Don't include the brackets!) The text should be
          enclosed in the appropriate comment syntax for the file format. We also recommend that a file or class name
          and description of purpose be included on the same "printed page" as the copyright notice for easier
          identification within third-party archives.
          <br />
          <br />
          Copyright [yyyy] [name of copyright owner]
          <br />
          <br />
          Licensed under the Apache License, Version 2.0 (the "License");
          <br />
          you may not use this file except in compliance with the License.
          <br />
          You may obtain a copy of the License at
          <br />
          <br />
          http://www.apache.org/licenses/LICENSE-2.0
          <br />
          <br />
          Unless required by applicable law or agreed to in writing, software
          <br />
          distributed under the License is distributed on an "AS IS" BASIS,
          <br />
          WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
          <br />
          See the License for the specific language governing permissions and
          <br />
          limitations under the License.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        5. BSD 2
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          Copyright (c) &lt;year&gt; &lt;owner&gt;.
          <br />
          <br />
          Redistribution and use in source and binary forms, with or without modification, are permitted provided that
          the following conditions are met:
          <br />
          <br />
          1. Redistributions of source code must retain the above copyright notice, this list of conditions and the
          following disclaimer.
          <br />
          2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the
          following disclaimer in the documentation and/or other materials provided with the distribution.
          <br />
          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
          WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
          PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY
          DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
          PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
          CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
          OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
          DAMAGE.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        6. BSD Zero
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          BSD Zero Clause License
          <br />
          Copyright (C) YEAR by AUTHOR EMAIL
          <br />
          <br />
          Permission to use, copy, modify, and/or distribute this software for any purpose with or without fee is hereby
          granted.
          <br />
          <br />
          THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH REGARD TO THIS SOFTWARE
          INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
          ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM LOSS OF USE,
          DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN
          CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        7. BSD 3
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          Copyright (c) &lt;year&gt; &lt;owner&gt;.
          <br />
          <br />
          Redistribution and use in source and binary forms, with or without modification, are permitted provided that
          the following conditions are met:
          <br />
          <br />
          1. Redistributions of source code must retain the above copyright notice, this list of conditions and the
          following disclaimer.
          <br />
          2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the
          following disclaimer in the documentation and/or other materials provided with the distribution.
          <br />
          3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or
          promote products derived from this software without specific prior written permission.
          <br />
          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED
          WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A
          PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY
          DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
          PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER
          CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR
          OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH
          DAMAGE.
          <br />
        </div>
        <br />
      </Typography>

      <Typography
        tabIndex={0}
        variant='subtitleMedium'
        component='div'
        gutterBottom
        sx={{fontWeight: (theme) => theme.typography.fontWeightRegular}}
      >
        8. Unlicense
      </Typography>
      <Typography tabIndex={0} variant='captionLarge' component='div' gutterBottom>
        <div>
          License Text:
          <br />
          This is free and unencumbered software released into the public domain.
          <br />
          <br />
          Anyone is free to copy, modify, publish, use, compile, sell, or distribute this software, either in source
          code form or as a compiled binary, for any purpose, commercial or non-commercial, and by any means.
          <br />
          <br />
          In jurisdictions that recognize copyright laws, the author or authors of this software dedicate any and all
          copyright interest in the software to the public domain. We make this dedication for the benefit of the public
          at large and to the detriment of our heirs and successors. We intend this dedication to be an overt act of
          relinquishment in perpetuity of all present and future rights to this software under copyright law.
          <br />
          <br />
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
          TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL
          THE AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
          OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          SOFTWARE.
          <br />
          For more information, please refer to &lt;http://unlicense.org&gt;
          <br />
        </div>
        <br />
      </Typography>
    </Root>
  )
}

export default LegalNotice
